module.exports = __webpack_public_path__ + "media/images/logo_pequeno_levoo-06f5c76ff1c91691f3df41b3e93c032b.png";